// react
import { createContext, useContext } from 'react';

export interface AdminViewModeContextValue {
  /** Whether admin view mode is currently active (already gated by `isAdmin`). */
  adminViewMode: boolean;
  setAdminViewMode: (nextValue: boolean) => void;
}

export const AdminViewModeContext = createContext<
  AdminViewModeContextValue | undefined
>(undefined);

export function useAdminViewMode() {
  const context = useContext(AdminViewModeContext);

  if (!context) {
    throw new Error(
      'useAdminViewMode must be used within AdminViewModeProvider',
    );
  }

  return context;
}
